if($('.type-detail').length){
    $('.p-image-wrapper').wrapInner('<div class="stickyImage"></div>')
    $('.p-info-wrapper').append($('.p-detail-inner .p-detail-inner-header').clone())
    $('.p-image-wrapper .p-image img').attr('src', $('.p-image-wrapper .p-image img').attr('src').replace('/big/', '/orig/'))
    $('.p-thumbnail').each(function(){
        $(this).attr('href', $(this).attr('href').replace('/big/', '/orig/'))
    })
    if($('.surcharge-list').length){
        $('.surcharge-list').each(function(){
            $(this).hide()
            var selectName = $(this).find('select').data('parameter-name')
            var selectID = $(this).find('select').data('parameter-id')
            var surchargeProductList = '<div class="variantRow">'
                if($(this).find('select').length){
                    surchargeProductList += '<div class="h3">'+selectName+'</div>'
                }
                surchargeProductList += '<div class="chooseRow">'
                $(this).find('select option').each(function(){
                    if ($.isNumeric($(this).attr('value'))){
                        var optionText = $(this).text()
                        surchargeProductList += '<div class="parameterInner variant" data-has-multiple="no" data-title-name="'+selectName+'" data-select-id="'+selectID+'" data-option-id="'+$(this).attr('value')+'">'
                            surchargeProductList += '<span class="textWrap">'
                                surchargeProductList += '<span class="name">'+optionText+'</span>'
                            surchargeProductList += '</span>'
                        surchargeProductList += '</div>'
                    }
                })
                surchargeProductList += '</div>'
            surchargeProductList += '</div>'
            $('.p-info-wrapper').append(surchargeProductList)
            
        })

    }

    $('.add-to-cart button').clone().appendTo('.p-info-wrapper')
}

$(document).on('click', '.chooseRow .parameterInner', function(){
    const variantData = $(this).data('option-id');
    const variantParameterId = $(this).data('select-id');
    if($(this).hasClass('active')){
        $("select[data-parameter-id='"+variantParameterId+"'] option").first().prop("selected", true).change();
        $(this).removeClass("active"); 
    }
    else{
        $("select[data-parameter-id='"+variantParameterId+"'] option").filter(function (){
            return $(this).attr('value') == variantData;
        }).change().prop("selected", true);
        $(this).addClass("active"); 
            
    }
        
       
      //  $(this).closest('.chooseRow[data-param-id="'+variantParameterId+'"]').find(".variant:not([data-value='"+variantData+"'])").removeClass("active");
        
    

    var selector = '.variant-list .hidden-split-parameter, .variant-list .split-parameter';
    var $splitParameters = $(selector);
    $splitParameters.trigger('change');
    $("select[data-parameter-id='"+variantParameterId+"']")[0].dispatchEvent(new Event('change'));
    $('.chooseRow .variant').each(function(){
        const variantData = $(this).data('value');
        const variantParameterId = $(this).data('parameter-id');
        const unavailable = $("select[data-parameter-id='"+variantParameterId+"'] option[value='" + variantData + "']").hasClass("unavailable-option");
        if (unavailable === true) {
            $(this).addClass("unavailable").removeClass("active");
        }
        else{
            $(this).removeClass("unavailable");
        } 
    });
});